import { BaseService } from "services/base-service";

import { API_ROUTES } from "constants/routes";

class RolesService extends BaseService {
  constructor(url) {
    super(url);
    this.getRoles = this.getRoles.bind(this);
    this.getRoleById = this.getRoleById.bind(this);
  }

  async getRoles(params) {
    try {
      const response = await this.agent.get("", params);

      return Promise.resolve(response);
    } catch (error) {
      this.processError(error);
      return null;
    }
  }

  async getRoleById(id, params) {
    try {
      const response = await this.agent.get(`/${id}`, params);

      return Promise.resolve(response);
    } catch (error) {
      this.processError(error);
      return null;
    }
  }
}

const ServiceInstance = new RolesService(API_ROUTES.roles);

export default ServiceInstance;
export { ServiceInstance as RolesService };
